module.exports = __webpack_public_path__ + "static/media/sheding1.7a8e4a41.png";